<template lang="pug">
  .details-wrapper
    .region
      DBLabel(title="região:" :body="formatedRegion(company.region)")
    .ddd
      DBLabel(title="ddd:" :body="company.ddd")
    .phone1
      DBLabel(title="telefone 01:" :body="company.phone && company.phone[0]" :loading="loading")
    .phone2
      DBLabel(title="telefone 02:" :body="company.phone && company.phone[1]" :loading="loading")
    .phone3
      DBLabel(title="telefone 03:" :body="company.phone && company.phone[2]" :loading="loading")
    .phone4
      DBLabel(title="telefone 04:" :body="company.phone && company.phone[4]" :loading="loading")
    .priority
      DBLabel(title="prioridade:" :loading="loading")
        template(v-slot:body)
          .stars
            .icon-ptt-icons-estrela(v-for="n in priority")
            .icon-ptt-icons-estrela(v-for="n in fillStars" style="color: gray")
    .totalEmployees
      DBLabel(:title="`número de ${$wp('employee')}:`" :body="company.totalOfEmployees")
    .supervisor
      DBLabel(
        :title="`supervisor especifíco para ${$ws('company')}:`"
        :body="company.supervisor ? company.supervisor.name : ''"
        :loading="loading"
      )
    .checkbox
      DBLabel(title="")
        template(v-slot:body)
          PCheckbox(
            :label="`Mostrar este ${$ws('company')} no acompanhamento de entrada?`"
            v-model="appearOnRealtime"
            readonly
          )
          PCheckbox(
            :label="`Ativar ${$ws('company')}`"
            v-model="active"
            readonly
          )

    .actions-buttons
      PButton(color="success" size="md" @click="goToCompany(company)" title="ir para folha")
        .icon-ptt-icons-folha

      PButton(color="info" size="md" @click="editCompany" title="editar")
        .icon-ptt-icons-lapis

      PConfirmButton(text="Excluir local de trabalho?" color="danger" size="md" @click="removeCompany(company.id)" :loading="deleting" title="excluir")
        .icon-ptt-icons-excluir

</template>

<script>
import { getHierarchyName } from 'src/utils'
import DBLabel from 'src/common/SmartTable/DBLabel'

export default {
  name: 'Details',
  components: {DBLabel},
  props: {
    company: {type: Object, required: true},
    loading: {type: Boolean, required: true}
  },
  data () {
    return {
      deleting: false
    }
  },
  computed: {
    priority () {
      if (!this.company.priority) return 0
      return parseInt(this.company.priority)
    },
    fillStars () {
      if (!this.company.priority) return 0
      return 5 - parseInt(this.company.priority)
    },
    appearOnRealtime () {
      return this.company.appearOnRealtime ? this.company.appearOnRealtime : false
    },
    active () { return this.company.active ? this.company.active : false }
  },
  methods: {
    async removeCompany (companyId) {
      this.deleting = true
      try {
        await this.$API.company.delete({id: companyId})
        this.$swal({
          type: 'success',
          text: `${this.$ws('company')} deletado com sucesso`
        })
        this.$emit('updateTable', true)
      } catch (e) {
        const msg = e.data.error || 'Aconteceu um erro. Tente novamente.'
        this.$swal({
          type: 'error',
          title: 'Atenção',
          text: msg
        })
      }
      this.deleting = false
    },
    editCompany () {
      this.$router.push(`/company/${this.company.id}`)
    },
    goToCompany (company) {
      this.$router.goToTimesheet(new Date(), null, company, true)
    },
    formatedRegion (region) {
      const regions = this.$store.state.common.regions.items
      return regions.length ? getHierarchyName(region, regions) : ''
    }
  }
}
</script>

<style scoped lang="scss">
.details-wrapper {
  height: 100%;
  position: relative;
  display: grid;
  grid-template-columns: 1fr .7fr;
  grid-template-rows: .5fr .5fr .5fr .5fr .5fr 1fr;
  grid-column-gap: 20px;
  grid-template-areas:
    "region ddd"
    "phone1 phone2"
    "phone3 phone4"
    "priority priority"
    "supervisor totalEmployees"
    "checkbox buttons";

  .region { grid-area: region }
  .ddd { grid-area: ddd }
  .phone1 { grid-area: phone1 }
  .phone2 { grid-area: phone2 }
  .phone3 { grid-area: phone3 }
  .phone4 { grid-area: phone4 }
  .priority {
    grid-area: priority;

    .stars {
      display: flex;
    }
  }
  .totalEmployees { grid-area: totalEmployees }
  .supervisor { grid-area: supervisor }
  .checkbox { grid-area: checkbox }
  .actions-buttons {
    grid-area: buttons;
    justify-self: right;
    align-self: end;

    display: grid;
    grid-gap: 2px;
    grid-auto-flow: column;
  }
}
</style>
